// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#share-modal .modal-content .modal-body .icon-wrapper>div{display:flex;justify-content:space-between}@media(max-width:576px){#share-modal .modal-content .modal-body .icon-wrapper>div{flex-direction:column}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
